import { Route } from 'react-router-dom';
import KDSLayout from '../../components/KDS/KDSLayout';
import KDSDemo from '../../components/KDS/KDSDemo';

/**
 * KDS (Kitchen Display System) routes
 */
export const kdsRoutes = (
  <>
    <Route path="/kds/*" element={<KDSLayout />} />
    <Route path="/kds-demo" element={<KDSDemo />} />
  </>
);










